module.exports = __webpack_public_path__ + "static/img/gjsc1.5de3846.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/common/gjsc1.jpg
// module id = oQLF
// module chunks = 0